import React, { useEffect, useCallback } from 'react';
import ReactGA from 'react-ga4';
import { isAnalyticsEnabled, isDevUser, GA_TRACKING_ID } from './useAnalytics';
import { useLocation } from 'react-router-dom';

interface AnalyticsProps {
  /** React children to be wrapped with analytics tracking */
  children: React.ReactNode;
}

/**
 * Analytics wrapper component that initializes GA4 tracking and handles page views
 * @component
 * @param {AnalyticsProps} props - Component props
 * @returns {React.ReactElement} Wrapped children with analytics tracking
 */
export const Analytics: React.FC<AnalyticsProps> = ({ children }) => {
  const space = useLocation();

  // Memoize the route change handler to maintain the same reference
  const handleRouteChange = useCallback((url: string) => {
    if (isAnalyticsEnabled && !isDevUser) {
      ReactGA.send({
        hitType: "pageview",
        page: url
      });
    }
  }, []);

  useEffect(() => {
    if (!isAnalyticsEnabled || isDevUser) {
      console.log(
        "%c[Analytics] Analytics deshabilitados",
        "color: #4CAF50; font-weight: bold",
        "\nNo se enviarán eventos a Google Analytics"
      );
    } else {
      // Initialize GA4
      ReactGA.initialize(GA_TRACKING_ID);

      // Send the initial pageview
      handleRouteChange(space.pathname + space.search);
    }
  }, [handleRouteChange, space]);

  return <>{children}</>;
};

export default Analytics; 